export const RectangleIcon = () => {
  return (
    <svg width="45" height="45" viewBox="0 0 100 100">
      <rect x="15" y="25" width="70" height="50" fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};